import { Estate } from '/@/modules/estate/models/Estate';
import { User } from '/@/modules/user/models/User';
import { PredefinedJurisdiction } from '/@/modules/predefined/enums/PredefinedJurisdiction';
import { Paywall } from '@/modules/estate/models/Paywall';
import { Billing } from '@/modules/billing/models/Billing';
import { EstateQuebecSpouseClaim } from '@/modules/estate/models/EstateQuebecSpouseClaim';
import { EstateUpsell } from '@/modules/estateupsell/models/EstateUpsell';
import { EstateConsent } from '@/modules/estate/models/EstateConsent';
import { Disclaimer } from '@/modules/disclaimer/models/Disclaimer';

export class CurrentEstate extends Estate {
  estateAdminUsers: User[];

  hasOnboardedAtLeastOneExecutor: boolean;

  declare billing: Relationship<Billing> | null;

  declare estateQuebecSpouseClaim: Relationship<EstateQuebecSpouseClaim> | null;

  declare estateUpsell: Relationship<EstateUpsell> | null;

  declare estateConsents: Relationship<EstateConsent[]>;

  declare disclaimers: Relationship<Disclaimer[]>;

  paywall: Paywall;

  constructor(model: Partial<CurrentEstate> = {}) {
    super(model);

    this.estateAdminUsers = User.mapModels(model.estateAdminUsers);
    this.hasOnboardedAtLeastOneExecutor = model.hasOnboardedAtLeastOneExecutor as boolean;
    this.paywall = Paywall.mapModel(model.paywall);
  }

  get primaryEstateAdminUser(): User | undefined {
    return this.estateAdminUsers.find(
      (estateAdminUser: User) => estateAdminUser.estateAccount?.meta.isPrimary
    );
  }

  get isCommonLawJurisdiction(): boolean {
    return PredefinedJurisdiction.isCommonLawJurisdiction(this.jurisdictionId);
  }

  get isInQuebecJurisdiction(): boolean {
    return this.jurisdictionId === PredefinedJurisdiction.QUEBEC.id;
  }

  get isInCanadaJurisdiction(): boolean {
    return PredefinedJurisdiction.isCanadianJurisdiction(this.jurisdictionId);
  }

  get isInPrinceEdwardIslandJurisdiction(): boolean {
    return this.jurisdictionId === PredefinedJurisdiction.PRINCE_EDWARD_ISLAND.id;
  }

  get estateProfessionalEmails(): string[] {
    return this.estateAdminUsers
      .filter((user: User) => user.isEstateProfessional || user.isJuniorEstateProfessional)
      .map((user: User) => user.email) as string[];
  }

  get isUnPaidSelfServePlan(): boolean {
    return this.isSelfServePlan && !this.paywall.hasSelfServePlan;
  }

  get canAccessAccountingPage(): boolean {
    return !this.isSelfServePlan || this.paywall.hasSelfServePlan;
  }
}
